import { render, staticRenderFns } from "./CollectiveDetail.vue?vue&type=template&id=58233dbb&scoped=true"
import script from "./CollectiveDetail.vue?vue&type=script&lang=js"
export * from "./CollectiveDetail.vue?vue&type=script&lang=js"
import style0 from "./CollectiveDetail.vue?vue&type=style&index=0&id=58233dbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58233dbb",
  null
  
)

export default component.exports